export default "__VITE_ASSET__B1Swun9y__"